export default __webpack_public_path__ + "static/media/auditTrail.f9150986.svg";